import config from "console_config";
import { isTrialEnded } from "src/root/pages/components/utils";

export const getLeftPanelLinks = () => {
  const translations = [
    "links.auth.video_src",
    "auth.video_title",
    "auth.left_panel.video.title",
    "auth.left_panel.deploy_for_free.title"
  ] as const;

  const trialEnded =
    isTrialEnded() && config.ENABLE_TRIAL_AUTH_SUNSET_LEFT_SIDE;

  const result = Object.fromEntries(
    translations.map(t => {
      const value = trialEnded ? t : `${t}.legacy`;
      return [t, value];
    })
  ) as { [K in (typeof translations)[number]]: string };

  return result;
};
